import { postJSON, post, get } from '@/utils/axios'
import config from '@/utils/config'

// 会员卡卡种列表
export const cardTypeCfgList = () => get('cardTypeCfg/list')

// 出纳账户列表
export const cashierAccountCfgList = () => get('cashierAccountCfg/list')

//查询所有出纳账户列表
export const selectCashierAccountList = () => get('cashierAccountCfg/selectCashierAccountList')

// 支付方式列表
export const payTypeList = () => get('payType/list', {showList:'Ai优米收银台'})

// 商品列表
interface productSelectProjectListProps {
    page?: number //当前页
    orderBy?: string //排序
    size?: number //每页大小
    productName?: string //商品名称
}

export const productSelectProjectList = (options:productSelectProjectListProps) => postJSON('product/selectProjectList',options)

// 套餐列表
interface selectBaseComboListProps {
    page?: number //当前页
    orderBy?: string //排序
    size?: number //每页大小
    comboName?: string //套餐名称
}

export const selectBaseComboList = (options:selectBaseComboListProps) => postJSON('combo/selectBaseComboList',options)

// 服务列表
interface projectSelectProjectListProps {
    page?: number //当前页
    orderBy?: string //排序
    size?: number //每页大小
    projectName?: string //服务名称
    fastBilling?:number | string //常用服务(0:否，1:是)
}

export const projectSelectProjectList = (options:projectSelectProjectListProps) => postJSON('project/selectProjectList',options)

// 按客户pk查询客户信息
export const userInfo = (userPk:number | string) => get('userCard/selectUserCardInfoByUserPk',{userPk})

// 开卡/续卡
export const saleCard = (options) => postJSON('userCard/saleCard',options)



// 开卡/充值保存
export const cardRecharge = (options) => postJSON('userCard/cardRecharge',options)

// 按充值金额查询提成金额
export const getRechargeCommission = (rechargeAmount:number | string) => get('rechargeCommissionCfg/getRechargeCommission',{rechargeAmount}, {}, false)

// 二维码
interface wxQrCodeProps {
    sceneStr?: string //subscribe_当前组织的pk
    type ?:number | string //固定传0
}

export const wxQrCode = (options:wxQrCodeProps) => post(`/yme-wxmp/wx/qrCode/${config.appid}/create`,options, {}, false)

// 员工列表
export const getDirectSupervisor = (searchName:string = '', userStatus:string = '1') => get('/yme-system/staff/getDirectSupervisor',{searchName}, {}, false)

// 消费卡列表
export const cashBackCardTypeCfg = () => get('cashBackCardTypeCfg/list',{}, {}, false)

// 按会员卡pk查询会员卡详情
export const selectByCardPk = (cardPk) => get('userCard/selectByCardPk',{cardPk}, {}, false)


// 查询用户是否关注公众号
export const selectNickName = (userPk:string) => get('user/selectNickName',{userPk}, {}, false)

// 获取消费卡列表
export const getScoreCardList = (userPk: string) => get('userCashBackCard/list', { userPk })

// 查询消费卡详情
export const getScoreCardInfo = (cardPk: string) => get('userCashBackCard/selectCardInfoByUserPk', { cardPk })

// 查询消费卡记录
interface GetScoreCardUseHistoryOptions {
    cardPk: string // 消费卡PK
    page: number // 页码
    size: number // 每页大小
}
export const getScoreCardUseHistory = (options: GetScoreCardUseHistoryOptions) => get('userCashBackCard/cardUseRecords', options)

// 查询消费卡统计
export const getScoreCardTotal = (cardPk: string) => get('userCashBackCard/cashBackCardTabStatistics', {
    cardPk
})

// 会员卡可用车辆列表
export const userCardCardLimitCarList = (cardPk: string) => get('userCard/cardLimitCarList', {
    cardPk
})

//可抵扣付款列表
interface selectAvailablePaymentListProps {
    page?: string | number //当前页
    queryValue?: string //车牌、手机号、姓名查询条件
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    bizType?: string //单据类型0-其他收款 1-工单收款 2-挂账收款 3-会员卡收款 4-定金收款
}
export const selectAvailablePaymentList = (options:selectAvailablePaymentListProps) => postJSON('cashier/selectAvailablePaymentList', {
    ...options
})

// 其他收款
interface otherReceiptsProps {
    orgPk?: string //组织pk
    bizType?: string //单据类型0-其他收款 1-工单收款 2-挂账收款 3-会员卡收款 4-定金收款
    bizPk?: string //业务pk
    userPk?: string //客户PK
    phone?: string //客户电话
    carNo?: string //客户车牌
    face?: string //头像
    name?: string //名称
    openId?: string //openid
    paymentAmount?: string | number //付款总额
    remark?: string //备注
    source?: string //来源 0-H5 1-APP
}
export const otherReceipts = (options:otherReceiptsProps) => postJSON('cashier/otherReceipts', {
    ...options
})

//收款详情
export const selectSaleBillDetail = (orderNo:string) => post('cashier/selectSaleBillDetail', {
    orderNo
})